import { useLocalStorage as useLocalStorageFromReactUse } from "react-use";

export const useLocalStorage = useLocalStorageFromReactUse;
